import passengersMetaReducer from './passengersMetaReducer';

export default passengersMetaReducer;
